import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { JackingActivitiesRouterPage } from './jacking-activities-router-page';
import {SharedModule} from '../../shared/shared.module';
import {JackingActivityListV2Component} from '../v2/jacking-activity-list-v2/jacking-activity-list-v2.component';
import {GridModule} from '@progress/kendo-angular-grid';
import {JackingActivityListComponent} from '../v1/jacking-activity-list-component/jacking-activity-list-component.component';
import {DailyLogPageModule} from '../../daily-log/daily-log/daily-log.module';
import {JackingActivityEditV2PageModule} from '../v2/jacking-activity-edit-v2/jacking-activity-edit-v2.module';

@NgModule({
  declarations: [
    JackingActivitiesRouterPage,
    JackingActivityListV2Component,
    JackingActivityListComponent
  ],
  imports: [
    SharedModule,
    IonicPageModule.forChild(JackingActivitiesRouterPage),
    GridModule,
    DailyLogPageModule,
    JackingActivityEditV2PageModule,
  ],
})
export class JackingActivitiesRouterPageModule {}



// WEBPACK FOOTER //
// ./src/pages/jacking-activities/jacking-activities-router/jacking-activities-router-page.module.ts